import React from 'react'
import { observer } from 'mobx-react'
import Modal from 'react-modal'
import usePortManager from '../hooks/use-port-manager'
import usePriceManager from '../hooks/use-price-manager'
import useSettingsManager from '../hooks/use-settings-manager'
import SVGIcon from '../helpers/icons'

function ConfirmManualInstallation (props) {

  const port_manager = usePortManager()
  const price_manager = usePriceManager()
  const settings = useSettingsManager()

  const [modalIsOpen, setIsOpen] = React.useState(false)
  const [value, setValue] = React.useState('')
  const [accept, setAccept] = React.useState(false)

  const openModal = function () {
    setIsOpen(true)
  }
  const closeModal = function () {
    setIsOpen(false)
  }

  const confirm = function () {
    if (accept !== true) return
    port_manager.updateValue('installation', value)
    port_manager.updateValue('date', null)
    port_manager.updateValue('uninstallation', 'no')
    price_manager.updatePrice()
    closeModal()
  }

  const beforeUpdateValue = function (key, value) {
    setValue(value)
    openModal()
    return false // Don't let input set value
  }

  return (
    <React.Fragment>
      {React.Children.map(props.children, child =>
        React.cloneElement(child, { beforeUpdateValue: beforeUpdateValue }))}
      <Modal
        isOpen={modalIsOpen}
        shouldCloseOnOverlayClick={true}
        onRequestClose={closeModal}
        className={'confirm-manual-installation'}
      >
        <div className={'tip-modal-content form'}>
          <header className={'warning-header'}>
            <SVGIcon type={'warning'} fill={'#D14243'} className={'warning-icon'}/>
            <h3 className="warning">{settings.getOtherSettings('warning', 'Advarsel!')}</h3>
          </header>

          <div className={'content'}
               dangerouslySetInnerHTML={{ __html: settings.getOtherSettings('maninst_content', '<strong>FY</strong><p>Det må du ikke!</p>') }}></div>

          <label className={'checkbox-input'}>
            {settings.getOtherSettings('maninst_accept', 'Jeg accepterer')}
            <input type="checkbox" defaultChecked={accept} onChange={(e) => setAccept(e.target.checked)}/>
            <span className={'checkmark'}></span>
          </label>

          <button onClick={confirm}
                  className={'button primary'}>{settings.getOtherSettings('maninst_confirm', 'OK')}</button>

          <button onClick={() => setIsOpen(false)} aria-label={'Close modal'} className={'close-button'}>
            <SVGIcon type={'close'} fill={'#FFF'} className={'close-button__icon'}/>
          </button>
        </div>
      </Modal>
    </React.Fragment>
  )
}

export default observer(ConfirmManualInstallation)